import React from 'react';
import { ReactComponent as PlusHouseIcon } from '../../assets/svg/plus-house.svg';
import '../primitives/Button.css';

/**
 * Unified "Add New" button used across dashboard cards.
 * Props:
 *  - onClick: action handler
 *  - label (optional): override text (defaults to "Add New")
 *  - size: 'sm' | 'md' (defaults sm for card headers)
 *  - ariaLabel: accessibility label override
 *  - disabled
 */
export default function AddNewButton({ onClick, label = 'Add New', size = 'md', ariaLabel, disabled }) {
  const sizeClass = size === 'sm' ? 'ui-btn--sm' : (size === 'lg' ? 'ui-btn--lg' : 'ui-btn--md');
  return (
    <button
      type="button"
      className={`ui-btn ui-btn--neutral ui-btn--add ${sizeClass}`}
      onClick={onClick}
      aria-label={ariaLabel || label}
      disabled={disabled}
    >
      <span className="ui-btn__icon" aria-hidden="true"><PlusHouseIcon /></span>
      <span className="ui-btn__label">{label}</span>
    </button>
  );
}
